module.exports = __webpack_public_path__ + "static/media/biocore-essential-pack.19927418.png";